import DropDownMenu from '@/sections/NavBar/DropDownMenu'
import { SolutionsDesktopMenu } from '@/sections/NavBar/SolutionsMenu'

const SolutionsDropDownMenu = () => {
    return (
        <DropDownMenu header={'Solutions'}>
            <SolutionsDesktopMenu />
        </DropDownMenu>
    )
}

export default SolutionsDropDownMenu
